import { createContext, useContext } from 'react'

export interface TutorialApi {
  /** Abre o guia. `aPartirDoPasso`: id do passo, id do passo do "Primeiros passos" (percorre só o grupo) ou índice. */
  iniciarTutorial: (id: string, aPartirDoPasso?: string | number) => void
  encerrarTutorial: () => void
  /** Id do tutorial em andamento. */
  ativoId: string | null
}

export const TutorialContext = createContext<TutorialApi | null>(null)

export function useTutorial(): TutorialApi {
  const ctx = useContext(TutorialContext)
  if (!ctx) throw new Error('useTutorial precisa estar dentro de <TutorialProvider>.')
  return ctx
}
